$(document).ready(function () {

    /**
     * Toutes les x minutes, on demande à l'utilisateur s'il souhaite resté connecté.
     * Les temps sont en millisecondes.
     */
    if ($('span.nav-item--text:contains("Sinistres")').length > 0) {
        // Profil concerné (Agent de recouvrement) pour ne avoir la modal de déconnexion.
    } else if ($('#btn-connexion').length < 1) {

        var timerAskRenewConnexion;

        function relanceTimerPreventDeconnexion() {
            clearTimeout(timerAskRenewConnexion);
            timerAskRenewConnexion = setTimeout(function () {
                var timerDeconnexion = setTimeout(function () {
                    window.location = '/disconnect';
                }, 60000);
                modalOuiNon('Vous allez être déconnecté.\nSouhaitez vous prolonger votre connexion ?',
                    'Rester connecté ?', function () {
                        window.clearTimeout(timerDeconnexion);
                        $.get('renew_session');
                        relanceTimerPreventDeconnexion();
                    }, function () {
                        window.location = '/disconnect';
                    });
            }, SESSION_LIFETIME - 60000);
        }

        relanceTimerPreventDeconnexion();

        $(document).ajaxSend(function (e, request, settings) {
            if (settings.url.indexOf('api/messagerie/messages?filters=') === -1) {
                relanceTimerPreventDeconnexion();
            }
        });
    }

	// sliders
	var testimonials = $('.testimonials-slider');
	if (testimonials.length) {
		testimonials.slick({
			dots: true,
			arrows: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			fade: true,
			autoplay: true,
			autoplaySpeed: 4000
		});
	}

	var partners = $('.partners-slider');
	if (partners.length) {
		partners.slick({
			dots: false,
			arrows: true,
			prevArrow: '<button type="button" class="slick-prev"><span class="icon icon-previous"></span></button>',
			nextArrow: '<button type="button" class="slick-next"><span class="icon icon-next"></span></button>',
			slidesToShow: 5,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 2500,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 1,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
					}
				},
				{
					breakpoint: 470,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
					}
				}
			]
		});
	}

});



!function ($) {

    window.Zelok = {


        init: function() {

            // Properties
            this.accordionIconOpen   = 'fa-minus';
            this.accordionIconClose  = 'fa-plus';

            // Methods
            this.initAccordionIconToggle();
        },

        // ACCORDION ICON TOGGLE
        // Initializes once.
        initAccordionIconToggle: function() {
            var self = this;
            $(document).on('show.bs.collapse hide.bs.collapse', '.accordion', function (e) {
                var $target = $(e.target);
                $target.siblings('.accordion-heading')
                    .find('em').toggleClass(self.accordionIconOpen + ' ' + self.accordionIconClose);
                if (e.type == 'show') {
                    $target.prev('.accordion-heading').find('.accordion-toggle').addClass('active');
                }
                if (e.type == 'hide') {
                    $(this).find('.accordion-toggle').not($target).removeClass('active');
                }
            });
        },

    };

    Zelok.init();

}(window.jQuery);
